export const getFilters = ({ filters, pageFilters }: { filters: any; pageFilters: any }) => {
  const updatedFilters = { ...filters };

  if (pageFilters?.brands) {
    delete updatedFilters.brandsList;
  }

  if (pageFilters?.colors) {
    delete updatedFilters.colorsList;
  }

  if (pageFilters?.taxonomyLevel3 || pageFilters?.taxonomyLevel4) {
    delete updatedFilters.productCategoriesList;
  } else {
    // only show the productTypes under categories (only show taxonomyLevel2)
    if (pageFilters?.categories) {
      const firstLevelCategory = filters.productCategoriesList?.find(
        (c: any) => c.name?.toLowerCase() === pageFilters.categories?.toLowerCase(),
      );
      if (firstLevelCategory?.productTypesList) {
        updatedFilters.productCategoriesList = [firstLevelCategory];
      }
    }

    // only show the activities under productTypes (only show taxonomyLevel3)

    if (pageFilters?.productTypes) {
      let matchingProductType;
      const theCategory = filters.productCategoriesList?.find((category: any) => {
        return category.productTypesList?.find(
          (type: any) => type.name?.toLowerCase() === pageFilters.productTypes?.toLowerCase(),
        );
      });
      if (theCategory) {
        matchingProductType = theCategory.productTypesList?.find(
          (type: any) => type.name?.toLowerCase() === pageFilters.productTypes?.toLowerCase(),
        );
      }

      if (matchingProductType?.activitiesList) {
        updatedFilters.productCategoriesList = [
          { ...theCategory, productTypesList: [matchingProductType] },
        ];
      }
    }
  }

  return updatedFilters;
};
